export default {
  "root": "_root_2a8vt_1",
  "vhidden": "_vhidden_2a8vt_16",
  "button_reset": "_button_reset_2a8vt_36",
  "button": "_button_2a8vt_36",
  "day_selected": "_day_selected_2a8vt_59",
  "months": "_months_2a8vt_77",
  "month": "_month_2a8vt_77",
  "table": "_table_2a8vt_93",
  "with_weeknumber": "_with_weeknumber_2a8vt_99",
  "caption": "_caption_2a8vt_104",
  "multiple_months": "_multiple_months_2a8vt_112",
  "caption_dropdowns": "_caption_dropdowns_2a8vt_118",
  "caption_label": "_caption_label_2a8vt_123",
  "nav": "_nav_2a8vt_139",
  "caption_start": "_caption_start_2a8vt_143",
  "caption_end": "_caption_end_2a8vt_150",
  "nav_button": "_nav_button_2a8vt_157",
  "dropdown_year": "_dropdown_year_2a8vt_171",
  "dropdown_month": "_dropdown_month_2a8vt_172",
  "dropdown": "_dropdown_2a8vt_171",
  "dropdown_icon": "_dropdown_icon_2a8vt_208",
  "head": "_head_2a8vt_212",
  "head_row": "_head_row_2a8vt_216",
  "row": "_row_2a8vt_217",
  "head_cell": "_head_cell_2a8vt_221",
  "tbody": "_tbody_2a8vt_232",
  "tfoot": "_tfoot_2a8vt_236",
  "cell": "_cell_2a8vt_240",
  "weeknumber": "_weeknumber_2a8vt_248",
  "day": "_day_2a8vt_59",
  "day_today": "_day_today_2a8vt_267",
  "day_outside": "_day_outside_2a8vt_267",
  "day_range_start": "_day_range_start_2a8vt_290",
  "day_range_end": "_day_range_end_2a8vt_290",
  "day_range_middle": "_day_range_middle_2a8vt_314"
};import "ni:sha-256;EexsC4Bbl5294uspfWsIMylSEB60HlHTgGKc6ZwGjWg";